import { render, staticRenderFns } from "./wenzihuifu.vue?vue&type=template&id=fef441ac&scoped=true&"
import script from "./wenzihuifu.vue?vue&type=script&lang=js&"
export * from "./wenzihuifu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef441ac",
  null
  
)

export default component.exports